export default __webpack_public_path__ + "static/media/AutoGravity-4.8ded523b.jpg";